var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWinnerIcon = function SvgWinnerIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 137,
    viewBox: "0 0 147 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.955 28.5279H20.0455C15.1382 28.5279 11.1601 32.5321 11.1601 37.4714C11.1601 42.4107 15.1382 46.4149 20.0455 46.4149H126.955C131.862 46.4149 135.84 42.4107 135.84 37.4714C135.84 32.5321 131.862 28.5279 126.955 28.5279ZM20.0455 17.2949C8.97466 17.2949 0 26.3282 0 37.4714C0 48.6145 8.97467 57.6479 20.0455 57.6479H126.955C138.025 57.6479 147 48.6145 147 37.4714C147 26.3282 138.025 17.2949 126.955 17.2949H20.0455Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9706 6.48529C12.9706 2.90357 15.9817 0 19.6961 0H127.304C131.018 0 134.029 2.90357 134.029 6.48529C134.029 10.067 131.018 12.9706 127.304 12.9706H19.6961C15.9817 12.9706 12.9706 10.067 12.9706 6.48529Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2941 70.6172H80.7059V97.9995H66.2941V70.6172Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4412 105.725C50.4412 101.458 53.6962 98 57.7115 98H89.2885C93.3038 98 96.5588 101.458 96.5588 105.725V112.412H50.4412V105.725Z",
    fill: "#979797"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7941 112.412H105.206V136.912H41.7941V112.412Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7647 119.617H92.2353V128.264H54.7647V119.617Z",
    fill: "#979797"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3235 61.9707H93.6765C93.6765 69.9301 87.6543 76.3825 80.2255 76.3825H66.7745C59.3457 76.3825 53.3235 69.9301 53.3235 61.9707Z",
    fill: "#979797"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3823 12.9707H119.618V19.6361C119.618 45.4047 98.97 66.2942 73.5 66.2942C48.0299 66.2942 27.3823 45.4047 27.3823 19.6361V12.9707Z",
    fill: "#C4C4C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 21.6172L78.0248 31.0022L87.9118 32.6268L80.8212 40.0517L82.407 50.4407L73.5 45.6445L64.5931 50.4407L66.1788 40.0517L59.0883 32.6268L68.9753 31.0022L73.5 21.6172Z",
    fill: "#979797"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWinnerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/winnerIcon.0d7f9fcf2417754b525a7158f4d4c4f2.svg";